/** Canonical shop order URL: /{locale}/order/{shortToken} */
export function buildOrderPath(opts: { shortToken?: string | null; pay?: boolean; locale?: string }) {
  let params = new URLSearchParams();
  if (opts.pay) {
    params.set('pay', '1');
  }
  let query = params.toString();
  let prefix = opts.locale ? `/${opts.locale}` : '';
  return `${prefix}/order/${opts.shortToken || ''}${query ? `?${query}` : ''}`;
}
